import React from 'react';
import {
  Squares2X2Icon,
  ShoppingCartIcon,
  CubeIcon,
  BuildingStorefrontIcon,
  UsersIcon,
  ChartBarIcon,
  Cog6ToothIcon,
  ClockIcon,
  TagIcon,
  ShoppingBagIcon,
  ArrowUpTrayIcon,
  ArrowDownTrayIcon,
  PlusIcon,
  BanknotesIcon,
  FolderIcon,
  ShieldCheckIcon,
  BuildingOffice2Icon,
  ReceiptPercentIcon,
  CreditCardIcon,
  DocumentTextIcon,
  ExclamationTriangleIcon,
  ArrowsRightLeftIcon,
  PencilSquareIcon,
  ArrowPathIcon,
  BookOpenIcon,
  UserGroupIcon,
  IdentificationIcon,
  KeyIcon,
  ListBulletIcon,
  ClipboardDocumentListIcon,
  ArrowLeftIcon,
  MagnifyingGlassIcon,
  BellIcon,
  QuestionMarkCircleIcon,
  SunIcon,
  MoonIcon,
  XMarkIcon,
  Bars3Icon,
  ChevronRightIcon,
  ChevronLeftIcon,
  ChevronDownIcon,
  CheckCircleIcon,
  InformationCircleIcon,
  PaperAirplaneIcon,
  TableCellsIcon,
  TicketIcon,
  UserCircleIcon,
  TrophyIcon,
  MegaphoneIcon,
  ChatBubbleLeftRightIcon,
  ArrowTrendingUpIcon,
  EyeIcon,
  LockClosedIcon,
} from '@heroicons/react/24/outline';

const ICONS = {
  dashboard: Squares2X2Icon,
  products: TagIcon,
  sales: ShoppingCartIcon,
  stores: BuildingStorefrontIcon,
  inventory: CubeIcon,
  customers: UsersIcon,
  suppliers: UserGroupIcon,
  purchases: ReceiptPercentIcon,
  stocktransfers: ArrowsRightLeftIcon,
  staff: IdentificationIcon,
  roles: KeyIcon,
  reports: ChartBarIcon,
  settings: Cog6ToothIcon,
  history: ClockIcon,
  tag: TagIcon,
  upload: ArrowUpTrayIcon,
  download: ArrowDownTrayIcon,
  add: PlusIcon,
  money: BanknotesIcon,
  folder: FolderIcon,
  verified: ShieldCheckIcon,
  business: BuildingOffice2Icon,
  receipt: ReceiptPercentIcon,
  creditcard: CreditCardIcon,
  pointofsale: ShoppingBagIcon,
  addshoppingcart: ShoppingCartIcon,
  assignmentreturn: ArrowPathIcon,
  localoffer: TagIcon,
  accountbalance: BanknotesIcon,
  star: ShieldCheckIcon,
  description: DocumentTextIcon,
  warning: ExclamationTriangleIcon,
  swap: ArrowsRightLeftIcon,
  edit: PencilSquareIcon,
  sync: ArrowPathIcon,
  book: BookOpenIcon,
  group: UserGroupIcon,
  list: ListBulletIcon,
  listalt: ClipboardDocumentListIcon,
  auditlogs: DocumentTextIcon,
  back: ArrowLeftIcon,
  search: MagnifyingGlassIcon,
  notifications: BellIcon,
  help: QuestionMarkCircleIcon,
  sun: SunIcon,
  moon: MoonIcon,
  close: XMarkIcon,
  menu: Bars3Icon,
  chevronright: ChevronRightIcon,
  chevronleft: ChevronLeftIcon,
  chevrondown: ChevronDownIcon,
  checkcircle: CheckCircleIcon,
  info: InformationCircleIcon,
  send: PaperAirplaneIcon,
  table: TableCellsIcon,
  servicetickets: TicketIcon,
  attendance: ClockIcon,
  staffperformance: TrophyIcon,
  marketing: MegaphoneIcon,
  customerengagement: ChatBubbleLeftRightIcon,
  trendingup: ArrowTrendingUpIcon,
  trophy: TrophyIcon,
  megaphone: MegaphoneIcon,
  chatbubble: ChatBubbleLeftRightIcon,
  ticket: TicketIcon,
  restaurant: ShoppingBagIcon,
  assessment: ChartBarIcon,
  outbox: PaperAirplaneIcon,
  tune: PencilSquareIcon,
  visibility: EyeIcon,
  cashier: BanknotesIcon,
  lock: LockClosedIcon,
};

export default function Icon({ name, className = 'h-5 w-5', title }) {
  const Cmp = ICONS[name];
  if (!Cmp) return null;
  return <Cmp className={className} aria-hidden={title ? undefined : true} title={title} />;
}

